import React from "react"
import PropTypes from "prop-types"
import { Container, Row, Col } from "@ui/wrapper"
import BoxImage from "@components/box-image/layout-two"
import { SectionWrap } from "./section.style"
import { sectionIcons } from "../../../dataMantiz/pages/company/aboutUs/sectionIcons"

const BoxSection = ({ headingStyle, linkStyle }) => {
  return (
    <SectionWrap>
      <Container>
        <Row>
          {sectionIcons.map(item => {
            return (
              <Col
                lg={4}
                md={6}
                className="box-item"
                key={`box-image-${item.id}`}
              >
                <BoxImage imageSrc={item.imageSrc} title={item.title} />
              </Col>
            )
          })}
        </Row>
      </Container>
    </SectionWrap>
  )
}

BoxSection.propTypes = {
  headingStyle: PropTypes.object,
  linkStyle: PropTypes.object,
}

BoxSection.defaultProps = {
  headingStyle: {
    as: "h3",
    fontSize: "18px",
    fontweight: 500,
    lineHeight: 1.4,
    color: "#333333",
    mt: "40px",
    textalign: "center",
  },
  linkStyle: {
    layout: "underline",
    hover: {
      layout: 2,
    },
  },
}

export default BoxSection
